module.exports = __webpack_public_path__ + "static/media/equipment01.a5bded33.jpg";